import { defineComponent } from 'vue';

export default defineComponent({
  name: 'VEmpty',
  render() {
    return null;
  },
});
